import { createFileRoute } from '@tanstack/react-router';
import { CloseLayout } from '@/components/finance/close';

/**
 * CPH-001 + CPH-006: index route for the Close-the-period hub. Renders
 * the spine (`CloseLayout`) — `/admin/finance/close` without any
 * sub-segment lands here. The spine remains keyed on `FilingDeadline.Id`
 * via `useCurrentClosePeriod()` inside `CloseLayout`.
 */
export const Route = createFileRoute('/admin/finance/close/')({
  component: CloseLayout,
});
